@if (!reload) {
    <div [ngClass]="secondaryClassList">
        @if (pegaTemplateWarning) {
            <ap-panel type="secondary" style="border: 1px solid orange">
                <p ap-panel-body>
                    <ap-icon name="exclamation-triangle" color="warning" size="large"></ap-icon>
                    {{ pegaTemplateWarning }}
                </p>
            </ap-panel>
        }
        <ap-skip-link [targetElement]="skipLinkTarget">{{ 'mijn.overzicht.template.skipLink.title' | apContent }}</ap-skip-link>
        <ap-header
            layout="medium"
            [isLoggedIn]="true"
            [logoLink]="logoLink"
            [profileMenu]="profileMenu"
            [logoAriaLabel]="'mijn.overzicht.template.logo.aria-label' | apContent"
            [navigationItems]="navigationItems"
            (navigationClicked)="onNavigation($event)"
            (loginLogout)="onLoginLogout($event)"
            (profileItemClicked)="onProfileItemClicked($event)"
        >
        </ap-header>
        <div class="mijn-overzicht-template__header">
            <div class="canvas-medium">
                @if (loading) {
                    <mijn-overzicht-template-skeleton
                        [subtitle]="subtitle !== undefined"
                        [breadcrumb]="dynamicBreadcrumb !== undefined"
                        [amount]="amount !== undefined"
                        [primaryAction]="primaryActionLabel !== undefined"
                        [secondaryAction]="secondaryActionLabel !== undefined"
                    >
                    </mijn-overzicht-template-skeleton>
                }
                @if (!loading) {
                    @if (dynamicBreadcrumb) {
                        <mijn-overzicht-template-breadcrumb [breadcrumb]="dynamicBreadcrumb"> </mijn-overzicht-template-breadcrumb>
                    }
                    <div class="ap-flex ap-flex-row ap-flex-gap-2 margin-bottom-2">
                        @if (avatar) {
                            <div class="avatar" data-bb="avatar">
                                <ap-icon [name]="avatar" [title]="avatar" [manualSize]="36"> </ap-icon>
                            </div>
                        }
                        <div class="ap-flex-1 ap-align-self-end">
                            <h1>{{ title }}</h1>
                        </div>
                        @if (!subtitle) {
                            <ap-amount-display
                                [value]="amount"
                                [variant]="amountVariant"
                                [contrast]="amountContrast"
                                [emphasize]="true"
                                class="amount-display amount-display--bigger ap-align-self-center"
                                data-bb="amount-secondary"
                            >
                            </ap-amount-display>
                        }
                    </div>
                    @if (subtitle) {
                        <div class="ap-flex ap-flex-row ap-flex-gap-2 margin-bottom-2 margin-top--1">
                            <div class="ap-flex-1">
                                <span class="subtitle">{{ subtitle }}</span>
                            </div>
                            <ap-amount-display
                                [value]="amount"
                                [variant]="amountVariant"
                                [contrast]="amountContrast"
                                [emphasize]="true"
                                class="amount-display amount-display--bigger"
                                data-bb="amount-primary"
                            >
                            </ap-amount-display>
                        </div>
                    }
                    @if (secondarySubtitle) {
                        <div class="ap-flex ap-flex-row ap-flex-gap-2 margin-top--2">
                            <div class="ap-flex-1"></div>
                            <div data-bb="secondary-subtitle">
                                {{ secondarySubtitle }}
                                @if (secondarySubAmount) {
                                    <ap-amount-display
                                        [value]="secondarySubAmount"
                                        [variant]="amountVariant"
                                        class="amount-display"
                                        data-bb="amount-secondary-sub"
                                    >
                                    </ap-amount-display>
                                }
                            </div>
                        </div>
                    }
                    @if (hasActions()) {
                        <div class="ap-flex ap-flex-gap-2" [ngClass]="buttonsInColumns ? 'ap-flex-column' : 'ap-flex-row'">
                            @if (primaryActionLabel) {
                                <ap-button
                                    data-bb="primaryAction"
                                    [ngClass]="secondaryActionLabel ? 'ap-flex-basis-sm-50' : 'ap-flex-basis-sm-100'"
                                    [compact]="true"
                                    (onClick)="doPrimaryAction()"
                                >
                                    {{ primaryActionLabel }}
                                </ap-button>
                            }
                            @if (secondaryActionLabel) {
                                <ap-button
                                    data-bb="secondaryAction"
                                    [ngClass]="primaryActionLabel ? 'ap-flex-basis-sm-50' : 'ap-flex-basis-sm-100'"
                                    [compact]="true"
                                    (onClick)="doSecondaryAction()"
                                >
                                    {{ secondaryActionLabel }}
                                </ap-button>
                            }
                        </div>
                    }
                }
            </div>
        </div>
        <div class="mijn-overzicht-template__content canvas-medium">
            <main id="main-content">
                <ng-content></ng-content>
            </main>
        </div>
        @if (conversationalEnabled) {
            <mijn-overzicht-template-conversational
                [changeConversationalStatus$]="changeConversationalStatus$"
                (chatNotificationSent)="chatNotificationSent.emit($event)"
            ></mijn-overzicht-template-conversational>
        }
        @if (usabillaFormSettings && feedbackConfiguration) {
            <mijn-feedback
                [mijnFeedbackSettings]="mijnFeedbackSettings"
                [lastUsedSettings]="feedbackConfiguration.lastUsedSettings"
                [requiredMetadata]="feedbackConfiguration.requiredMetadata"
                (toContact)="toContact()"
            >
            </mijn-feedback>
        }
    </div>
}
